import useLocationHash from './useLocationHash';

export default function useLocationSharedCartId(): string {
    const hash = useLocationHash();
    // Shared cart IDs are UUIDv4 format, remove any other characters
    return hash.replace(/[^0-9a-zA-Z-]/g, '');
}
